import TranslationsConfigType from './translationType';

const nbTranslations: TranslationsConfigType = {
    annenEiendom: {
        labelGateadresse: 'Gateadresse',
        labelPostnummer: 'Postnummer',
    },
    barn: {
        title: 'Barn i husholdningen',
        subTitle:
            'Vi har hentet informasjon om dine barn under 18 år fra Folkeregistreret. ' +
            'Om du har barn under 18 år som ikke vises i listen, så skal disse legges til nedenfor.',
        subTitleGutt: 'Gutt',
        subTitleJente: 'Jente',
        labelFoedselsdato: 'Barnets fødselsdato',
        labelBetalerBarnebidrag: 'Betaler barnebidrag',
        labelMottarBarnebidrag: 'Mottar barnebidrag',
        labelSfoUtgifter: 'SFO',
        labelKjoenn: 'Hvilket kjønn er barnet?',
        radioTitleForeldreansvar: 'I hvilken grad har du foreldreansvar?',
        radioFullOmsorg: 'Full omsorg',
        radioDeltOmsorg: 'Delt omsorg',
        radioIngenOmsorg: 'Ingen omsorg',
        radioTitleSfo: 'Er barnet deltid eller heltid på SFO?',
        radioHeltid: 'Heltid',
        radioDeltid: 'Deltid',
        togglesHarBarn: 'Har du omsorg for barn under 18 år?',
        togglesBetalerBarnebidrag: 'Betaler du barnebidrag?',
        togglesMottarBarnebidrag: 'Mottar du barnebidrag?',
        togglesSfoUtgifter: 'Har du utgifter til SFO?',
        togglesGutt: 'Gutt',
        togglesJente: 'Jente',
        infoDsfError: 'Opplysningene kunne ikke hentes fra Folkeregisteret. Vennligst fyll ut skjemaet.',
    },
    biler: {
        title: 'Dine biler',
        titleHusholdning: 'Biler i husholdningen',
        subTitle:
            'Vi har hentet informasjon om biler du eier eller leaser fra Kjøretøyregisteret. ' +
            'Dersom du eier eller leaser andre biler, så kan du legge de til manuelt.',
        subTitleNb: 'NB: Gjelder kun biler hvor du er eier (ikke medeier).',
        subTitleHusholdning:
            'Her registrerer du informasjon om alle biler i husholdningen, også for eventuell medlåntaker.',
        labelLeaset: 'Månedlig utgift til leasing',
        radioBensin: 'Bensin/bensin-hybrid',
        radioDiesel: 'Diesel/diesel-hybrid',
        radioElektrisitet: 'Elektrisitet',
        radioTitleDrivstoff: 'Hvilket drivstoff bruker bilen?',
        toggelsErLeaset: 'Er bilen leaset?',
        toggelsHarBil: 'Har du bil?',
        toggelsHarBilHusholdning: 'Har du/dere bil i husholdningen?',
        eier: 'Eier',
        leasingtaker: 'Leasingeier',
        registreringsnummer: 'Registreringsnummer',
        drivstoff: 'Drivstoff',
        drivstoffTyper: {
            bensin: 'Bensin',
            diesel: 'Diesel',
            elektrisk: 'Elektrisk',
            hybridBensin: 'Hybrid (Bensin)',
            hybridDiesel: 'Hybrid (Diesel)',
            parafin: 'Parafin',
            gass: 'Gass',
            hydrogen: 'Hydrogen',
            annet: 'Annet',
            biodiesel: 'Biodiesel',
            biobensin: 'Biobensin',
            lpg: 'LPG',
            cng: 'CNG',
            metanol: 'Metanol',
            etanol: 'Etanol',
            komprimertLuft: 'Komprimert luft',
            lng: 'LNG',
            cngLng: 'CNG/LNG',
        },
    },
    boligPant: {
        togglesBoligPant: 'Har du gjeld med pant i denne boligen?',
        togglesBoligPantEksisterendeLaan: 'Har du annen gjeld med pant i denne boligen?',
        labelBoligPant: 'Restsaldo på gjeld',
    },
    boligSalg: {
        title: 'Selge bolig',
        infoLaanIDag: 'Lån i dag',
        infoAntattBoligverdi: 'Antatt boligverdi',
        labelHvilkenBoligSkalSelges: 'Hvilken bolig skal du selge?',
        togglesSelgeBolig: 'Har du en bolig som skal selges?',
        togglesHarPantIBolig: 'Har du gjeld med pant i denne boligen?',
    },
    boligVerdi: {
        title: 'Boligverdi',
        titleLaanbeloep: 'Boligverdi og lånebeløp',
        infoAntattBoligverdi: 'Antatt boligverdi',
        infoAndelFellesgjeld: 'Andel fellesgjeld',
        infoNyEtakstverdi: 'Ny boligverdi fra E-takst',
        infoNyEtakstFellesgjeld: 'Ny fellesgjeld fra E-takst',
        infoLaanIDag: 'Lån i dag',
        infoIkkeFunnet: 'Ikke funnet',
        labelRestgjeld: 'Hva er restgjeld på lånet som skal flyttes?',
        labelLaanebeloep: 'Hvor mye ønsker du å låne?',
        labelOekelaan: 'Hvor mye ønsker du å øke lånet med?',
        labelFraBank: 'I hvilken bank er lånet i dag?',
        togglesOekeLaan: 'Ønsker du å øke det nye lånet?',
    },
    button: {
        avbryt: 'Avbryt',
        ja: 'Ja',
        fjern: 'Fjern',
        forrige: 'Forrige',
        fortsett: 'Fortsett',
        fortsettSoeknad: 'Fortsett søknad',
        gaaTilForsiden: 'Gå til forsiden',
        gaaTilbakeTilSoeknad: 'Gå tilbake til søknaden',
        iconButtonInformasjon: 'Informasjon',
        iconButtonMinus: 'Minus',
        iconButtonPlus: 'Plus',
        iconButtonSlett: 'Slett',
        lagre: 'Lagre',
        lagreOgFortsett: 'Lagre og fortsett senere',
        leggTilBil: 'Legg til bil',
        leggTilBarn: 'Legg til flere barn',
        leggTilArbeidsinntekt: 'Legg til ny arbeidsinntekt',
        leggTilGjeld: 'Legg til gjeld',
        loggInnPaaNytt: 'Logg inn på nytt',
        loggUt: 'Logg ut',
        lukk: 'Lukk',
        nei: 'Nei',
        neste: 'Neste',
        provIgjen: 'Prøv igjen',
        send: 'Send',
        sendSoeknad: 'Send søknad',
        slettSoeknad: 'Slett søknaden',
        bekreftSlettSoeknad: 'Bekreft sletting',
        startNySoeknad: 'Start ny søknad',
        startSoeknadPaaNytt: 'Start søknad på nytt',
        avsluttSoeknad: 'Avslutt søknad',
    },
    deleteSoeknad: {
        title: 'Ønsker du å lagre det du har fyllt ut hittil?',
        subTitle: 'Hvis du vil fullføre søknaden senere, så lagrer vi den i 7 dager.',
        titleBekreft: 'Er du sikker på at du vil slette søknaden?',
        subTitleBekreft: 'Hvorfor ønsker du å slette søknaden din? (Valgfritt)',
        titleSoeknadSlettet: 'Søknaden er slettet',
        soeknadErSlettet:
            'Om du har gitt tilbakemelding lagres dette anonymt, og vil brukes til å forbedre tjenestene våre.',
    },
    egenkapital: {
        title: 'Egenkapital',
        subTitle: 'Vi trenger informasjon om egenkapitalen din for å kunne beregne hvor mye du/dere kan låne.',
        labelEgenkapital: 'Egenkapital',
        subLabelEgenkapital: 'Oppgi kun din del av egenkapitalen om du har en medlåntaker på søknaden.',
        togglesEgenkapital: 'Har du sparepenger som skal benyttes som egenkapital i boligkjøpet?',
        checkboxEgenkapital: {
            title: 'Hvor kommer egenkapitalen din fra?',
            loenn: 'Lønn',
            pensjon: 'Pensjon',
            sparing: 'Sparing',
            trygd: 'Trygd',
            arvEllerGave: 'Arv eller gave',
            egenkapitalSalgEiendom: 'Egenkapital fra eiendomssalg',
            annen: 'Annet',
        },
        modalInfoBox: {
            titleHarSparepenger: 'Har du sparepenger som skal benyttes som egenkapital?',
            harSparepenger:
                'Fyll ut penger du har på konto i bank eller i fond som du kan bruke til boligkjøp. ' +
                'Forbrukslån godtas ikke som egenkapital.',
            titleHvorKommerEgenkapitalFra: 'Hvor kommer egenkapitalen din fra?',
            hvorKommerEgenkapitalFra:
                'Hvitvaskingsloven pålegger bankene å ha kunnskap om sine kunder. ' +
                'Et av kravene er at vi må vite hvor kundenes penger kommer fra. ' +
                'Du kan krysse av på ett eller flere av valgene.',
        },
    },
    eiendomBruk: {
        label: 'Hva skal boligen brukes til?',
        selectValueBo: 'Bolig jeg skal bo i',
        selectValueUtleie: 'Bolig jeg skal leie ut',
        selectValueFritid: 'Fritidsbolig / hytte',
    },
    eiendomList: {
        title: 'Hvilken bolig gjelder søknaden?',
        annenEiendom: 'Oppgi annen adresse',
    },
    eiendomVariant: {
        labelTypeBolig: 'Type bolig',
        labelTypeBoligSerEtter: 'Hvilken type bolig ser du etter?',
        selectValueEnebolig: 'Enebolig',
        selectValueLeilighet: 'Leilighet',
        selectValueRekkehus: 'Rekkehus',
        selectValueTomannsbolig: 'Tomannsbolig',
        selectValueSelveier: 'Selveier',
        selectValueAndelIBorettslag: 'Andel i borettslag',
        selectValueAksjeleilighet: 'Aksjeleilighet',
    },
    etakst: {
        togglesLabel: 'Har du en oppdatert E-takst?',
        togglesSublabel: 'E-takst må være nyere enn tre måneder',
        inputLabel: 'E-takstens referanse',
        inputSubLabel: 'Den består av 5 tegn, og du finner den i E-takst filen fra megler.',
        invalidETakst: 'Referanse er ikke gyldig',
        validETakst: 'Gyldig referanse for E-takst',
        infoETakst: 'Ny boligverdi fra E-takst',
        infoModalTitle: 'Hva er en E-takst? ',
        infoModalParagraf1:
            'En elektronisk takst (E-takst) er en bransjestandard for verdivurdering. Den er basert på statistiske data om tilsvarende boliger i området og meglers erfaring med salg i dagens boligmarked. E-taksten inneholder boligens verdi og hva den kan bli solgt for i dagens marked.',
        infoModalParagraf2:
            'For å kunne gi deg en realistisk boligverdi, vil en eiendomsmegler komme på befaring for å vurdere boligen. Selve dokumentasjonen og E-taksten lagres i et felles system, som både du og banken får tilgang til.',
    },
    errorDsfModal: {
        title: 'Feil ved henting av kundeinformasjon',
        description: 'Det har oppstått feil ved henting av kundeinformasjon. Prøv igjen seinere.',
    },
    finansieringsbevis: {
        title: 'Bolig',
        subTitle: 'Denne søknaden er for deg som ønsker å søke boliglån, men ikke har funnet en konkret bolig ennå.',
        formTitle: 'Hei,',
        formSubTitle: 'Vi trenger litt informasjon om boligen du skal kjøpe.',
    },
    flytteBoliglaan: {
        title: 'Velg bolig',
        subTitle: 'Denne søknaden er for deg som har et eksisterende boliglån du ønsker å flytte til oss.',
        formTitle: 'Hei,',
        formSubTitle: 'Vi trenger litt informasjon om boligen du har belånt i dag.',
    },
    gjeld: {
        title: 'Gjeld',
        subTitle:
            'Vi henter inn gjelden din fra ulike registere. Dersom du har annen gjeld så er det viktig at du legger det til.',
        infoTitle: 'Dette henter vi inn:',
        infoGjeldIBank: 'Gjeld i banken fra bankens kjernesystem',
        infoUsikretGjeld: 'Usikret gjeld som for eksempel kredittkort og forbrukslån fra Gjeldsregisteret',
        infoStudielaan: 'Studielån fra forrige skatteoppgjør via Altinn',
        infoAndelFellesgjeld: 'Andel fellesgjeld fra Eiendomsverdi dersom du eier en borettsandel',
        infoBillaan: 'Lån med pant i bil fra Dun & Bradstreet',
        infoBilensKjennetegn: 'Bilens kjennetegn',
        infoBilPant: 'Pant i bilen',
        infoSamletGjeld: 'Samlet gjeld',
        infoSamletGjeldErstattes: 'Gjeld som skal nedbetales med nytt lån',
        infoGjeldSum: 'Samlet gjeld',
        infoGjeldInfrisSum: 'Gjeld som skal nedbetales med nytt lån',
        infoGjeldsregister:
            'Logg inn hos Gjeldsregisteret for detaljer om gjeld dersom du er usikker på hva postene er',
        infoGjeldsregisterError: 'Opplysningene kunne ikke hentes fra Gjeldsregisteret. Vennligst fyll ut skjemaet.',
        infoDagensSaldo: 'Dagens saldo',
        infoDagensKredittramme: 'Dagens kredittramme',
        infoKredittramme: 'Kredittramme',
        infoRestgjeld: 'Restgjeld',
        infoTypeLaan: 'Type lån',
        infoInnfris: 'Erstattes av det nye lånet.',
        labelBankensNavn: 'Bankens navn',
        labelRestGjeld: 'Hva er restgjeld på kreditten?',
        labelMaanedligeFellesutgifter: 'Hva er dine månedlige fellesutgifter til borettslaget?',
        labelBillaanSaldo: 'Hva er dagens saldo på billånet?',
        labelRestGjeldStudielaan: 'Restgjeld på studielånet',
        labelTypeLaan: 'Type lån / kreditt',
        subTitleBoliglaan: 'Boliglån',
        subTitleStatensLaanekasse: 'Statens Lånekasse',
        subTitleKredittkort: 'Kredittkort',
        subTitleForbrukslaan: 'Forbrukslån',
        subTitleFaktureringskort: 'Faktureringskort',
        subTitleBillaan: 'Billån',
        selectValueDefault: 'Velg et alternativ',
        selectValueBillaan: 'Billån',
        selectValueStudielaan: 'Studielån',
        selectValueBoliglaan: 'Boliglån',
        selectValueAnnet: 'Annet',
        toggelsNedbetaleGjeld: 'Skal denne gjelden nedbetales med nytt lån?',
        toggelsHarGjeld: 'Har du lån eller kreditter?',
    },
    inntekt: {
        title: 'Inntekt',
        subTitle:
            'Vi har hentet lønnsslipper for siste halvår og siste skattemelding fra Skatteetaten. Dersom du har annen arbeidsinntekt legger du de til her.',
        labelArbeidsgiver: 'Arbeidsgiver',
        labelInntekt: 'Årlig inntekt før skatt',
        radioTitleArbeidssituasjon: 'Hva er din arbeidssituasjon?',
        radioFastAnsatt: 'Fast ansatt',
        radioMidlertidigAnsatt: 'Midlertidig ansatt',
        radioMottakerAvPensjon: 'Mottaker av pensjon/trygd',
        radioSelvstendigNaeringsdrivende: 'Selvstendig næringsdrivende',
        toggelsHarInntekt: 'Har du skattepliktig inntekt?',
        toggelsErNaavaerendeInntekt: 'Er dette din nåværende inntekt?',
        infoSblError:
            'Det har skjedd en feil ved henting av inntektsopplysninger fra Skatteetaten. Prøv igjen seinere eller legg til inntekt og fortsett søknaden.',
    },
    kjoepBolig: {
        title: 'Velg bolig',
        subTitle:
            'Denne søknaden er for deg som har funnet en ny bolig du ønsker å kjøpe, eller som du allerede har kjøpt.',
        formTitle: 'Hei,',
        formSubTitle: 'Vi trenger litt informasjon om boligen du har kjøpt eller skal kjøpe.',
        labelGateadresse: 'Gateadresse',
        labelPostnummer: 'Postnummer',
        labelKjoepesum: 'Kjøpesum',
        subLabelKjoepesum: 'Uten omkostninger',
        labelAndelFellesgjeld: 'Andel fellesgjeld',
        labelOvertakelse: 'Forventet dato for overtakelse',
        labelAndel: 'Velg riktig andel',
        labelMatrikkel: 'Velg riktig seksjon',
    },
    kontaktinfoHovedlaantaker: {
        title: 'Din kontaktinformasjon',
        subTitle: 'For å kunne kontakte deg i etterkant av søknaden, trenger vi din kontaktinformasjon.',
        labelMobil: 'Mobil',
        labelEpost: 'Epost',
    },
    kontaktinfoMedlaantaker: {
        togglesHarMedlaantaker: 'Har du medlåntaker?',
        title: 'Medlåntakers kontaktinformasjon',
        labelFornavn: 'Fornavn og evt. mellomnavn',
        labelEtternavn: 'Etternavn',
        labelFoedselsnummer: 'Fødselsnummer',
        labelMobil: 'Mobil',
        labelEpost: 'Epost',
        infoEksisterendeMedlaantaker:
            'Vi sender SMS og epost til medlåntaker med videre instruks etter at du har fullført og sendt inn din del av søknaden.',
        infoNyMedlaantaker:
            'Det kreves at du fyller ut fullt navn og fødselsnummer til din medlåntaker, slik at vi kan være sikre på at det er riktig person. ' +
            'Vi sender SMS og epost til medlåntaker med videre instruks etter at du har fullført og sendt inn din del av søknaden.',
        navnEksisterendeMedlaantaker: 'Navn',
    },
    kvittering: {
        title: 'Takk for din søknad!',
        paragrafLaantaker:
            'Vi har mottatt søknaden og sender deg kvittering på SMS og e-post. Du hører fra oss så snart saken blir behandlet.',
        paragrafMedlaantaker1:
            'Vi har sendt ut SMS/e-post til {navn} som må fullføre sin del av søknaden før den sendes ut. Når dette er gjort vil dere høre fra oss når saken blir behandlet.',
        paragrafMedlaantaker2: 'Husk å logge av denne brukeren før medlåntaker starter sin del av søknaden.',
        paragrafTilbakemelding:
            'Vi er ikke i mål, men jobber hele tiden for å gjøre søknadsprosessen enklere og raskere',
        titleTilbakemelding: 'Hjelp oss å gjøre søknadsprosessen bedre!',
        togglesTilbakemelding: 'Likte du søknadsskjemaet for boliglån?',
        labelTilbakemelding: 'Har du innspill, ønsker eller forbedringsforslag?',
        subLabelTilbakemelding:
            'Meldingen din er anonym og vi kan derfor ikke svare deg. Dersom du trenger hjelp må du kontakte kundeservice direkte.',
        infoTilbakemeldingTakk: 'Takk for tilbakemeldingen!',
        infoTilbakemeldingViktig: 'Din mening er viktig for oss.',
        verdivurderingFeil:
            'Forespørsel om verdivurdering til Aktiv eiendomsmegling feilet. Du kan sende ny forespørsel på aktiv.no',
    },
    laanebeloep: {
        title: 'Lånebeløp',
        infoDittBoliglaanIDag: 'Ditt boliglån i dag',
        infoLaanIDag: 'Lån i dag',
        infoKredittrammeIDag: 'Kredittramme i dag',
        infoMaksimaltLaanebeleop: 'Maksimal økning',
        labelLaaneoekning: 'Hvor mye ønsker du å øke lånet med?',
        labelOensketLaanebeloep: 'Hvor mye ønsker du å låne?',
        labelNedbetalingstid: 'Hvor lang nedbetalingstid (år) ønsker du?',
        infoNyttBoliglaan: 'Nytt boliglån',
        infoNyttBoliglaanOverstiger:
            'Forutsetter at du har inntekt nok til å betjene lånet og at lånet ikke overstiger fem ganger inntekten din.',
        infoNyttLaanebeloep: 'Nytt lånebeløp',
        infoNyNebetalingstid: 'Ny nedbetalingstid',
        infoNyttMaanteligBeloep: 'Nytt månedlig beløp',
        infoBelaaningsgrad: 'Belåningsgrad',
        infoNyKredittramme: 'Ny kredittramme',
        infoLinkOmBergning: 'Om beregning',
        popupInfoLaanIDag:
            'Om du har boliglån på den valgte boligen hos oss, så benytter vi dagens lånesaldo i beregningen.',
        popupInfoMaksimaltOekning:
            'Du kan maksimalt låne fem ganger din og en evt. medlåntakers inntekt. Beregningen tar ikke hensyn til eventuell mottatt eller avgitt realkausjon.',
        popupInfoSubTitleLaanIDag: 'Lån i dag',
        popupInfoSubTitleMaksimaltOekning: 'Maksimal økning av boliglån',
        popupInfoTitle: 'Om beregning',
        subLabelOensketLaanebeloep:
            'Estimert utifra dagens belåningsgrad og boligverdi, kan du øke boliglånet med inntil {maksoekning} kr.',
        warningLaaneoekning60:
            'Rammen på et flexilån kan maksimalt utgjøre 60% av boligens verdi.' +
            'Med denne låneøkningen kan det være at flexilånet må gjøres om til en nedbetalingslån.',
        warningLaaneoekning90:
            'Ønsket låneøkning ser ut til å overstige kravet om maksimal 90% belåning på bolig. ' +
            'Vi gjør oppmerksom på at det kan bli stilt krav om betryggende tilleggssikkerhet eller en ny ' +
            'verdivurdering av boligen dersom du ønsker å fortsette søknaden med dette lånebeløpet.',
        formaal: 'Hva er formålet med opplåningen?',
        formaalOppussing: 'Oppussing av bolig',
        formaalByggeBolig: 'Bygge på bolig',
        formaalKjoepeBil: 'Kjøp av bil',
        formaalInnfriGjeld: 'Innfri annen gjeld',
        formaalAnnet: 'Annet',
        formaalAnnetTitle: 'Beskriv formålet med opplåningen',
    },
    laaneformaal: {
        title: 'Søknad om boliglån',
        subTitle: 'Det kreves innlogging med BankID for å fullføre lånesøknaden.',
        labelLaaneformaal: 'Hva skal boliglånet benyttes til?',
        labelKjoepFinansieringsbevis: 'Har du funnet en bolig du ønsker å kjøpe?',
        selectValueKjoepBolig: 'Kjøpe bolig',
        selectValueOekelaan: 'Øke boliglånet ditt',
        selectValueFlytteLaan: 'Flytte lånet fra en annen bank',
        selectValueByggeRenovereBolig: 'Bygge eller totalrenovere bolig',
        selectValueKonkretBolig: 'Ja, jeg søker om lån til kjøp av en konkret bolig',
        selectValueFinansieringsbevis: 'Nei, jeg lurer på hvor mye jeg kan låne til å kjøpe bolig (finansieringsbevis)',
        infoKjoepBolig: 'For deg som søker om finansieringsbevis eller lån til å kjøpe bolig.',
        infoOekelaan:
            'For deg som har boliglån i dag og ønsker å øke dette. Dette valget brukes også hvis du ønsker å søke om nytt lån på gjeldsfri bolig.',
        infoFlytteLaan:
            'For deg som har boliglån i en annen bank og ønsker et nytt uforpliktende tilbud. Her kan du søke om økning av lånet som flyttes.',
        infoByggeRenovereBolig: 'For deg som ønsker å bygge eller totalrenovere bolig.',
    },
    leieinntekt: {
        title: 'Leieinntekter',
        subTitle:
            'Her registrerer du informasjon om alle leieinntekter i husholdningen, også for en eventuell medlåntaker.',
        subTitleUtleiekontrakt: 'Last opp utleiekontrakt (Valgfritt)',
        labelSkattefrieLeieinntekt: 'Månedlig skattefri leieinntekt',
        labelSkattepliktigLeieinntekt: 'Månedlig skattepliktig leieinntekt',
        toggelsHarSkattefrieLeieinntekt: 'Har du, eller vil du få, skattefrie leieinntekter?',
        toggelsHarSkattepliktigLeieinntekt: 'Har du, eller vil du få, skattepliktig leieinntekter?',
        infoUteleikontrakt1:
            'Vi må se signert utleiekontrakt for hvert leieforhold for å kunne ta med disse inntektene i beregningen.',
        infoUteleikontrakt2:
            'Om du ikke har dette tilgjengelig akkurat nå, så sender vi deg en oppgave om dette etter at søknaden er sendt inn.',
    },
    medlaantaker: {
        titleDeresSoeknad: 'Deres søknad',
        infoNaavaerendeBoliglaan: 'Nåværende boliglån',
        infoOensketOekning: 'Ønsket økning',
        infoDereSoekerOm: 'Dere søker om ',
        infoOver: 'over',
        titleOppfoertSomMedlaantaker: 'Du er oppført som medlåntaker',
        infoOekeBoliglaan:
            '{navn} har oppgitt deg som medlåntaker i en søknad om å øke deres boliglån. Vi trenger ditt samtykke med BankID, og informasjon om din arbeidssituasjon, inntekt og gjeld før søknaden kan behandles.',
        infoFlytteBoliglaan:
            '{navn} har oppgitt deg som medlåntaker i en søknad om å flytte deres boliglån. Vi trenger ditt samtykke med BankID, og informasjon om din arbeidssituasjon, inntekt og gjeld før søknaden kan behandles.',
        infoKjoepeBolig:
            '{navn} har oppgitt deg som medlåntaker i en søknad om boliglån. Vi trenger ditt samtykke med BankID, og informasjon om din arbeidssituasjon, inntekt og gjeld før søknaden kan behandles.',
        infoFinasiertingsbevis:
            '{navn} har oppgitt deg som medlåntaker i en søknad om finansiering til ny bolig. Vi trenger ditt samtykke med BankID, og informasjon om din arbeidssituasjon, inntekt og gjeld før søknaden kan behandles.',
        subTitleKontaktinfo: 'Kontaktinformasjon',
        labelDinEpost: 'Din e-post',
        labelDittMobilnr: 'Ditt mobilnummer',
    },
    oekeBoliglaan: {
        title: 'Velg bolig',
        subTitle:
            'Denne søknaden er for deg som ønsker å låne mer på din nåværende bolig, til f.eks vedlikehold eller oppgraderinger.',
        formTitle: 'Hei,',
        formSubTitle:
            'Vi henter de boligene du står som eier av fra Eiendomsregisteret. Kommer ikke boligen din opp, kan du legge den til manuelt.',
    },
    oppsummering: {
        title: 'Oppsummering',
        subTitleKontaktinfo: 'Kontaktinformasjon',
        subTitleBeskjedRaadgiver: 'Ønsker du å legge til en beskjed til rådgiver?',
        infoNaavaerendeBoliglaan: 'Nåværende boliglån',
        infoFlytteBoliglaan: 'Flytte boliglån',
        infoFinansieringsbevis: 'finaniseringsbevis.',
        infoOensketOekning: 'Ønsket økning',
        infoNyttBoliglaan: 'Nytt boliglån',
        infoKjoepBolig: 'boliglån med adresse',
        infoDereSoekerOm: 'Dere søker om',
        infoDuSoekerOm: 'Du søker om',
        infoOver: 'over',
        infoSms:
            'Vi sender en sms og e-post til {navn} med videre instruksjoner, slik at hen kan fullføre sin del av søknaden.',
        infoSend:
            'Ved å sende inn søknaden bekrefter jeg at de oppgitte opplysninger om min økonomiske situasjon er korrekte, og at det kan foretas en kredittsjekk av meg som jeg vil motta en bekreftelse på. Jeg er også kjent med at eventuelle uriktige eller tilbakeholdte opplysninger eller dokumentasjon fra min side kan resultere i at innvilget kreditt og  kredittavtalen heves av banken.',
        labelBeskjed: 'Beskjed (valgfritt)',
        labelDinEpost: 'Din e-post',
        labelDittMobilnr: 'Ditt mobilnummer',
        labelMedlaantakerEpost: 'Medlåntakers e-post',
        labelMedlaantakerMobilnr: 'Medlåntakers mobilnummer',
    },
    paabegyntSoeknadModal: {
        title: 'Vi fant en påbegynt søknad',
        description: 'Ønsker du å fortsette på denne søknaden?',
    },
    pageCard: {
        neste: 'Neste',
    },
    pageHeader: {
        finansieringsbevis: 'Søknad om finansieringsbevis',
        flytteBoliglaan: 'Søknad om å flytte boliglån',
        kjoepeBolig: 'Søknad om å kjøpe bolig',
        refinansiereBoliglaan: 'Søknad om å øke boliglånet',
        nyttBoliglaan: 'Søknad om nytt boliglån',
    },
    pageName: {
        barn: 'Barn i husholdningen',
        biler: 'Biler i husholdningen',
        boligsalg: 'Selge bolig',
        boligverdi: 'Boligverdi',
        egenkapital: 'Egenkapital',
        geolokasjon: '',
        gjeld: 'Gjeld',
        inntekt: 'Inntekt',
        kontaktinformasjon: 'Din kontaktinformasjon',
        kvittering: '',
        laanebeloep: 'Lånebeløp',
        leieinntekt: 'Leieinntekter',
        oppsummering: 'Oppsummering',
        samtykke: 'Samtykke',
        vedlegg: 'Vedlegg',
    },
    samtykke: {
        title: 'Samtykke',
        subTitle: 'For å vurdere din lånesøknad trenger vi ditt samtykke til å hente ut informasjon om deg.',
        infoTitle: 'Vi henter informasjon fra følgende kilder digitalt',
        infoSkatt: 'Skatte- og inntektsopplysninger fra Skatteteaten',
        infoGjeld: 'Informasjon om gjeld fra Skatteetaten og Gjeldsregisteret',
        inforDsf: 'Informasjon om sivilstatus og barn fra Folkeregisteret',
        infoKreditt: 'Vi gjennomfører også en kredittsjekk når du sender inn søknaden',
        infoSamtykke: 'Du må logge inn og gi samtykke hos Altinn for å gå videre med søknaden digitalt.',
        infoError:
            'Automatisk innhenting av skatt og inntektsopplysninger fungerer ikke akkurat nå. Kom tilbake senere, eller trykk “Neste” for å fortsette søknaden uten forhåndsutfylte opplysninger.',
        infoSamtykkeAkseptert:
            'Vi har mottatt ditt samtykke og forhåndsutfylt informasjonen i søknaden. Se over og fullfør utfyllingen før du sender inn søknaden.',
        infoAutomatiskBehandlet:
            'Ved å gå videre samtykker jeg til at banken oppretter en lånesøknad og lagrer nødvendige data om meg. Søknaden kan bli behandlet automatisk. Du kan lese mer om automatiske prosesser og hvordan vi behandler personopplysningene dine på',
    },
    userMessage: {
        tittleError: 'Noe gikk feil',
        tittleTimeout: 'Du ble logget ut',
        tittleNotFound: 'Søknad ikke funnet',
        titleSystemUnavaiable: 'En feil har oppstått',
        tittleSoeknadExists: 'Vi fant en påbegynt søknad',
        tittleMedlaantakerActive: 'Vi fant en aktiv søknad',
        tittleGeoOmmrade: 'Bosatt utenfor bankens markedsområde?',
        tittleSoeknadSendtInn: 'Søknad sendt inn',
        tittleUnder18: 'Under aldersgrense',
        descriptionError: 'Det har skjedd en feil ved henting av data. Prøv igjen eller fortsett seinere.',
        descriptionTimeout:
            'Det gikk for lang tid uten aktivitet, så du ble logget ut. Opplysningene dine lagres i 10 dager, så du kan logge inn for å fullføre søknaden når det passer deg.',
        descriptionNotFound: 'Vi finner ingen aktive søknader på deg.',
        descriptionSystemUnavaiable:
            'Vi får ikke hentet nødvendige opplysninger fra Folkeregisteret for øyeblikket. Det fungerer derfor ikke å søke om boliglån nå. Vennligst prøv igjen senere.',
        descriptionSoeknadExists: 'Ønsker du å fortsette på denne søknaden?',
        descriptionMedlaantakerActive:
            'Du får beskjed så snart din medlåntaker har fullført sin del av søknaden. Søknaden går deretter videre til en rådgiver for behandling.',
        descriptionGeoOmmrade:
            'Banken tilbyr primært boliglån til personer bosatt i bankens markedsområde. Det ser ut til at du er bosatt et annet sted. Ring banken så hjelper vi deg videre.',
        descriptionSoeknadSendtInn: 'Søknad er sendt inn. Du må starte ny søknad hvis du ønsker å endre søknaden.',
        descriptionUnder18:
            'Du må være over 18 år og bosatt i Norge for å søke om boliglån digitalt. Ta kontakt med banken dersom du har spørsmål.',
    },
    validationMessage: {
        foedselsdatoUnder18aar: 'Ugyldig fødselsdato, må være under 18år',
        patternEpost: 'Ugyldig epost format',
        patternTlf: 'Ugylig mobilnummer, må inneholde nøyaktig 8 siffer',
        requiredChoose: 'Vennligst velg et alternativ',
        requiredValue: 'Vennligst fyll ut dette feltet',
        nedbetalingsTidValue: 'Nedbetalingstid må være mellom 1 og 30 år',
        foedselsnummerToShort: 'Fødselsnummer må inneholde minst 11 siffer',
        foedselsnummerToLong: 'Fødselsnummer må ikke inneholde mer enn 11 siffer',
        personnummerNavnDsf: 'Angitt personnummer samsvarer ikke med angitt navn i Folkeregisteret',
        postnummerToLong: 'For langt postnummer',
        postnummerToShort: 'For kort postnummer',
        invalidPostnummer: 'Ugyldig postnummer',
        invalidDato: 'Ugyldig datoformat',
        minDato: 'Dato må være frem i tid',
        maxDato: 'Dato er for langt frem i tid',
    },
    vedlegg: {
        title: 'Vedlegg (valgfritt)',
        subTitleLastOppVedlegg:
            'Dersom du har vedlegg som er relevante for din lånesøknad kan du laste opp disse her. ',
        subTitleVedlegg: 'Vedlegg',
        infoMegabyte: 'MB',
        infoTotalt: 'Totalt',
        infoVedlegg: 'Eksempel: Ny ansettelseskontrakt om du nettopp har byttet jobb',
        infoSky: 'Dra filer hit, eller',
        linkButtonSky: 'velg filer her',
        radioTitleKategori: 'Hva slags fil er dette?',
        radioAnsettelseskontrakt: 'Ansettelseskontrakt',
        radioHusleiekontrakt: 'Husleiekontrakt',
        radioKontoutskrift: 'Kontoutskrift',
        radioAnnet: 'Annet',
        feilmeldingTittel: 'Følgende feil skjedde under opplasting av filer:',
        feilFiltype: 'Filen {filnavn} har en filtype som ikke støttes ({filtype}).',
        feilFilForStor: 'Filen {filnavn} er for stor. Maks filstørrelse er 4MB.',
        feilFilForLiten: 'Filen {filnavn} er for liten.',
        feilForMangeFiler:
            'Du har forsøkt å laste opp for mange filer på en gang, prøv å laste opp færre filer av gangen.',
        feilStandard: 'Det skjedde en feil, prøv igjen.',
        feilTotaltFilstoerrelse: 'Størrelsen på alle filer kan ikke være større enn 25MB',
        laster: 'laster...',
    },
    boligAdresseInfo: {
        typeBolig: 'Type bolig ',
        matrikkel: 'Matrikkel ',
        matrikler: 'Matrikler ',
        selveier: 'Selveier ',
        borettslag: 'Borettslag ',
        orgNr: 'Org.nummer ',
        andelsnummer: 'Andelsnummer ',
        fellesgjeld: 'Andel i fellesgjeld ',
    },
    geolokasjon: {
        title: 'Ønsker du å kjøpe bolig i vårt nærområde?',
        subTitle: 'Hei, {fornavn}',
        infoGeolokasjon: {
            hovedinfo:
                'For å opprettholde vår rolle som lokalbank ønsker vi at nye kunder er bosatt innenfor vårt lokalområde.',
            subinfo:
                'I følge Folkeregisteret er du bosatt utenfor vårt område. Om dette ikke stemmer eller du har planer om å kjøpe bolig i vårt lokalområde så er du selvfølgelig velkommen til å fortsette søknaden.',
        },
        linkInfo: 'Se oversikt over vårt lokalområde',
        modalTitle: 'Vårt lokalområde',
        modalsubtitle: 'Liste med postnummer',
        modalPoststed: '{postnummer}',
    },
    verdivurdering: {
        title: 'Ønsker du en verdivurdering av boligen din? ',
        subTitle: 'Tjenesten leveres av Aktiv Eiendomsmegling AS.',
        samtykke:
            'Jeg samtykker til at {banknavn} deler mitt mobilnummer, min e-post og boligens adresse med Aktiv Eiendomsmegling AS, slik at jeg kan kontaktes om verdivurdering av bolig.',
        lesMer: 'Du kan lese mer om Aktivs vilkår for personvern på aktiv.no',
        samtykkeError:
            'Samtykke kreves når du har svart ja på ønsket om verdivurdering av din bolig. For å komme videre må du endre svaret ditt til Nei, eller gi samtykke til deling av opplysningene med Aktiv.',
        endreButton: 'Endre svaret til Nei',
        samtykkeButton: 'Gi samtykke til deling',
        infoModal: {
            title: 'Få verdivurdering',
            tilgang:
                'For å kunne bestille verdivurdering hos Aktiv Eiendomsmegling må de få tilgang til følgende informasjon:',
            epost: 'din epost',
            tlf: 'ditt mobilnummer',
            adresse: 'boligens adresse',
            ansvar: 'Aktiv Eiendomsmegling blir ansvarlig for videre behandling av disse personopplysningene. Du kan lese mer om deres vilkår for personvern på aktiv.no',
        },
    },
    ok: 'Ok',
};

export default nbTranslations;
